import TextInput from "../../../../component/TextInput/TextInput";
import {PickDateTime} from "../../../../component/PickDate/PickDate";
import ExceptionGoodForm from "../../../../component/ExceptionGoodForm/ExceptionGoodForm";
import ExceptionPersonForm from "../../../../component/ExceptionPersonForm/ExceptionPersonForm";

const DiscountCodeForm = ({discountCode, onChange}) => {

    const changeDiscountCode = (key, value) => {
        const newDiscountCode = {...discountCode, [key]: value}
        if (key == "billDiscountAmount"){
            newDiscountCode.billDiscountPercent = "";
            newDiscountCode.maxBillDiscount = "";
        }else if (key == "billDiscountPercent" || key == "maxBillDiscount"){
            newDiscountCode.billDiscountAmount = "";
        }
        if (key == "deliveryDiscountAmount"){
            newDiscountCode.deliveryDiscountPercent = "";
            newDiscountCode.maxDeliveryDiscount = "";
        }else if (key == "deliveryDiscountPercent" || key == "maxDeliveryDiscount"){
            newDiscountCode.deliveryDiscountAmount = "";
        }
        onChange(newDiscountCode);
    }

    return (
        <div className="row">
            <div className="col-12">
                <TextInput label={"مناسبت تخفیف"} value={discountCode.description} onChange={(value) => {
                    changeDiscountCode("description", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput classname={"ltr"} label={"کد تخفیف"} value={discountCode.code} onChange={(value) => {
                    changeDiscountCode("code", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput type={"number"} label={"حداقل میزان فاکتور"} value={discountCode.minimumBillAmount}
                           onChange={(value) => {
                               changeDiscountCode("minimumBillAmount", value)
                           }}/>
            </div>
            <div className="col-md-6">
                <PickDateTime label={"انقضای کد"} timestamp={discountCode.expirationTimestamp} onChange={(value) => {
                    changeDiscountCode("expirationTimestamp", value)
                }}/>
            </div>
            <div className="col-md-6">
                <TextInput type={"number"} label={"حداکثر تعداد استفاده"} value={discountCode.numberOfUse}
                           onChange={(value) => {
                               changeDiscountCode("numberOfUse", value)
                           }}/>
            </div>

            <div className="col-md-5">
                <TextInput type={"number"} label={"مبلغ تخفیف روی فاکتور"} value={discountCode.billDiscountAmount}
                           onChange={(value) => {
                               changeDiscountCode("billDiscountAmount", value)
                           }}/>
            </div>

            <div className="col-md-2">
                <TextInput type={"number"} label={"درصد تخفیف روی فاکتور"} value={discountCode.billDiscountPercent}
                           onChange={(value) => {
                               changeDiscountCode("billDiscountPercent", value)
                           }}/>
            </div>
            <div className="col-md-5">
                <TextInput type={"number"} label={"حداکثر تخفیف روی فاکتور"} value={discountCode.maxBillDiscount}
                           onChange={(value) => {
                               changeDiscountCode("maxBillDiscount", value)
                           }}/>
            </div>
            <div className="col-md-5">
                <TextInput type={"number"} label={"مبلغ تخفیف روی ارسال"} value={discountCode.deliveryDiscountAmount}
                           onChange={(value) => {
                               changeDiscountCode("deliveryDiscountAmount", value)
                           }}/>
            </div>
            <div className="col-md-2">
                <TextInput type={"number"} label={"درصد تخفیف روی ارسال"} value={discountCode.deliveryDiscountPercent}
                           onChange={(value) => {
                               changeDiscountCode("deliveryDiscountPercent", value)
                           }}/>
            </div>
            <div className="col-md-5">
                <TextInput type={"number"} label={"حداکثر تخفیف روی ارسال"} value={discountCode.maxDeliveryDiscount}
                           onChange={(value) => {
                               changeDiscountCode("maxDeliveryDiscount", value)
                           }}/>
            </div>

            <div className="col-12">
                <ExceptionGoodForm exceptionGood={discountCode.exceptionGood} onChange={(value) => {
                    changeDiscountCode("exceptionGood", value)
                }} />
            </div>

            <div className="col-12">
                <ExceptionPersonForm exceptionPerson={discountCode.exceptionPerson} onChange={(value) => {
                    changeDiscountCode("exceptionPerson", value)
                }} />
            </div>


        </div>
    );
}

export default DiscountCodeForm;